export default "__VITE_ASSET__CowfoMvZ__"